<template>
  <div class="product-list-wrap" :style="{ height: contentHeight + 'px' }">
    <div class="line-title">
      <div class="left-title">
        <span class="text">Product List</span>
        <span class="count">{{ value.length }} {{ value.length > 1 ? 'Items' : 'Item' }}</span>
      </div>
      <div class="btn-group" v-if="editable">
        <div class="continuous-btn-no-bg">
          <div class="btn" @click="handleAdd" v-if="canAddItem">New Item</div>
        </div>
        <div class="btn-with-icon-with-bg" @click="handleRefresh">
          <span class="iconfont icon-refresh">&#xe611;</span>
        </div>
      </div>
      <!-- <div class="btn-with-icon-with-bg custom-save-btn" >
        <span class="iconfont icon-plus" @click="handleAdd">&#xe689;</span>
      </div> -->
    </div>
    <div class="table-wrap">
      <el-table
        class="cqm-table"
        highlight-current-row
        size="mini"
        :data="value"
        height="100%"
        style="width: 100%"
        @row-dblclick="editProduct"
      >
        <el-table-column
          align="center"
          type="index"
          label=""
          width="50">
        </el-table-column>
        <el-table-column
          width="250"
          prop="productName"
          label="Product / NPI Description">
          <template slot-scope="scope">
            <span class="click-btn" @click="editProduct(scope.row,scope.$index)">{{ scope.row.productType=='NPI' ? scope.row.npiDesc : scope.row.productName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="110"
          prop="productType"
          label="Product Type">
          <template slot-scope="scope">
            <span>{{ getEnumLabel(productTypeOptions, scope.row.productType) }}</span>
          </template>
        </el-table-column>
        
        <el-table-column
          width="160"
          prop="model"
          label="Model">
        </el-table-column>
        <el-table-column
          width="130"
          prop="ean"
          label="EAN10">
        </el-table-column>
        <el-table-column
          width="180"
          prop="priceWithTax"
          label="Avg. Unit Price (Inc. Tax)">
          <template slot-scope="scope">
            <span>￥{{ scope.row.priceWithTax }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          prop="priceWithoutTax"
          label="Avg. Unit Price (Exc. Tax)">
          <template slot-scope="scope">
            <span>￥{{ scope.row.priceWithoutTax }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          width="100"
          prop="taxRate"
          label="Tax Rate">
        </el-table-column> -->
        <el-table-column
          width="120"
          prop="annualQty"
          label="Est. Annual Qty">
        </el-table-column>
        <el-table-column
          width="160"
          prop="projectQty"
          label="Est. Project Period Qty">
        </el-table-column>
        <el-table-column
          width="150"
          prop="deliveryStart"
          label="Est. Delivery Start">
          <template slot-scope="scope">
            <span>{{ formatDateNoTime(scope.row.deliveryStart) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="deliveryEnd"
          label="Est. Delivery End">
          <template slot-scope="scope">
            <span>{{ formatDateNoTime(scope.row.deliveryEnd) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name:'OpportunityProductList',
  props:{
    //产品列表数据（v-model 双向绑定，父组件保留为提交时的数据源）
    value:{
      type:Array,
      default:()=>[]
    },
    //Product Type 下拉数据源，由父组件传入 enumerate.oppProductType
    productTypeOptions:{
      type:Array,
      default:()=>[]
    },
    //是否可新增产品：仅编辑既有商机(非 New)时为 true，由父组件传 !isNew；新增模式下隐藏右上角加号按钮
    editable:{
      type:Boolean,
      default:false
    },
    //是否显示“New Item”按钮：由父组件传 form.status==10（仅 Open 状态可新增产品行）
    canAddItem:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      //表格区可用的固定高度(px)：本组件自行测量计算，不依赖父组件传值
      contentHeight:0
    }
  },
  methods:{
    /* 计算表格区可用高：视口高 − 固定头部(.head-wrap) − 吸顶头(.detail-sticky-head) − 底部间距常量 30。
       30 直接抄自 Detail/index.vue 的 General 区(margin-top14 + .opportunity-detail margin-bottom10 + 缓冲6)，保证两个 tab 底部留白一致；
       本组件自行测量、不依赖父组件传值，使父组件高度逻辑变化不影响表格。 */
    handleResize(){
      this.$nextTick(()=>{
        let headEl = document.querySelector('.head-wrap')
        let headHeight = headEl ? headEl.offsetHeight : 0
        let stickyEl = document.querySelector('.detail-sticky-head')
        let stickyH = stickyEl ? stickyEl.offsetHeight : 0
        let h = window.innerHeight - headHeight - stickyH - 30
        this.contentHeight = h > 200 ? h : 200
      })
    },
    /* 根据 value 从枚举数组里取 label */
    getEnumLabel(list,value){
      if(!list || !list.length){
        return value
      }
      let target = list.find(item=>item.value==value)
      return target ? target.label : value
    },
    handleAdd(){
      //新增：向父组件 emit 打开一个空白产品详情页（不再使用弹窗）
      this.$emit('open-detail', {})
    },
    handleRefresh(){
      //刷新：通知父组件重拉产品列表（列表数据由父组件统一维护）
      this.$emit('refresh')
    },
    /* 打开编辑产品详情页（向父组件 emit，不再使用弹窗） */
    editProduct(row,index){
      this.$emit('open-detail', row, index)
    }
  },
  mounted(){
    //本组件自行测量可用高；因量的是全局固定头/吸顶头(与 tab 无关)，隐藏时也能算准
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('load', this.handleResize)
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('load', this.handleResize)
  }
}
</script>

<style lang="less" scoped>
@import url('/public/css/public.less');
.product-list-wrap{
  margin-top: 14px; /* 与上方 General Data 区块保持一致的顶部间距 */
  text-align: left;
  /* 全高独立滚动布局(参考 index.vue 的 General Information)：高度由父组件传入的 contentHeight 固定为视口可用高，标题栏固定、表格区占满剩余高度并内部滚动 */
  display: flex;
  flex-direction: column;
  min-height: 0;
  /* 分区标题 - 样式与 Cart overview .order .title 一致 */
  .line-title{
    min-height: 40px; /* JS 未测得时的兜底高 */
    flex-shrink: 0;
    padding: 0 14px; /* 去掉上下 padding，高度完全由绑定值控制，内容靠 align-items:center 居中 */
    background-color: @lightOrange;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    flex-shrink: 0; /* 标题栏固定在顶部，不随表格滚动 */
    .left-title{
      .text{
        font-weight: 600;
        margin-right:10px;
      }
      .count{
        font-size: 12px;
      }
    }
    .btn-group{
      display: flex;
      align-items: center;
    }
  }
  /* 表格 */
  .table-wrap{
    margin-top: 8px;
    /* 占满 .product-list-wrap 剩余高度；表格自身用 el-table 的 height="100%" 管理内部滚动(表头固定、行内容纵向滚动、超宽时横向滚动) */
    flex: 1;
    min-height: 0;
    .click-btn{
      color: @mainColor;
      &:hover{
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
</style>
